module.exports = __webpack_public_path__ + "static/img_oneoff_05@2x-07f8b22552ccd419448e7fcbdd36f5e1.png";